import { render, staticRenderFns } from "./ErpIcmBackupType.vue?vue&type=template&id=8e6b6778&scoped=true&"
import script from "./ErpIcmBackupType.vue?vue&type=script&lang=js&"
export * from "./ErpIcmBackupType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6b6778",
  null
  
)

export default component.exports